<template>

  <NdsDlg
      v-if="selectedApplic"
      :isOpen.sync="isNdsDlgOpen"
      :application="selectedApplic"
      @update:isOpen="val => {
      isNdsDlgOpen = val;
      if (!val) selectedApplic = null;
    }"
  />

  <div class="d-flex justify-space-between align-end">
    <v-card-title class="cardTitle">{{ $t('Заявка') }}</v-card-title>
    <v-spacer />
    <v-chip
      v-if="statusName"
      :color="bgColor"
      style="align-self: center"
      :style="{ '--circle-color': color, color: color }"
      variant="flat"
    >
      {{ statusName }}
    </v-chip>
  </div>
  <v-container>
    <PositionsView
      class="mb-3"
      v-if="positions?.length > 0 || tableReplaceCaption"
      :positions="positions"
      :nds-rate="ndsRate"
      :procedureStep="procedureStep"
      :table-replace-caption="tableReplaceCaption"
      :procedure-type="procedureType"
      :show-start-max-price="showStartMaxPrice"
      :show-sum-price="showSumPrice"
      short-name by-application no-card grey-style
    />
    <v-text-field
        variant="underlined"
        readonly
        :label="$t('Ценовое предложение')"
        :model-value="' '"
    >
      <span
          class="price"
          style="cursor: pointer;"
          :style="{ cursor: sums.ndsValue ? 'pointer' : 'default' }"
          @click="sums.ndsValue ? openDialog() : null"
      >
        {{formatChousenSum}}
      </span>
      <span
          v-if="sums.full > 0 && sums.full !== sums.chousen"
          class="not-chousen ml-1"
          :style="{ cursor: sums.ndsValue ? 'pointer' : 'default' }"
          @click="sums.ndsValue ? openDialog(true) : null"
      >
          {{formatFullSum}}
        </span>
    </v-text-field>

    <v-text-field
        style="pointer-events: none;"
        variant="underlined"
        readonly
        :label="$t('Наименование организации')"
        :model-value="checkValue(contragent.fullName)"
    />
    <v-text-field
        v-if="contragent.inn"
        style="pointer-events: none;"
        variant="underlined"
        readonly
        :label="$t('CRN')"
        :model-value="checkValue(contragent.inn)"
    />
    <v-text-field
        v-if="contragent.phone"
        style="pointer-events: none;"
        variant="underlined"
        readonly
        :label="$t('Телефон')"
        :model-value="checkValue(contragent.phone)"
    />
    <v-text-field
        v-if="contragent.mail"
        style="pointer-events: none;"
        variant="underlined"
        readonly
        :label="$t('Адрес электронной почты')"
        :model-value="checkValue(contragent.mail)"
    />
    <SupplierRequirementValuesView
      v-if="supplierRequirementValues?.length > 0"
      :supplier-requirement-values="supplierRequirementValues"
      class="mb-3"
      no-card
    />
    <file-input
      class="mt-3"
      :title="$t('Документы заявки')"
      :noCard="true"
      :documents="documents"
      :download-file="downloadDocument"
      :download-all-files="() => downloadDocuments()"
      :format-file-info="[
        (file) => formatMinuteTimeNoTZ(file.createdAt),
        (file) => file.fileSizeFmt.toLowerCase(),
      ]"
    >
      <template v-slot:file-icon="{ document }">
        <FileIcon :document="document" />
      </template>
    </file-input>
    <v-btn
      flat
      class="mt-10"
      color="primary"
      density="comfortable"
      variant="outlined"
      @click="closeAction"
    >{{ $t('Назад') }}</v-btn>
  </v-container>
</template>

<script>
import api from "@/api";
import FileInput from "@intec/vue-components/form/FileInput.vue";
import PositionsView from "@/components/positions/PositionsView.vue";
import {formatMinuteTimeNoTZ, formatMoneyText} from "@/filters";
import {useDialogStore} from "@/stores/dialog";
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";
import SupplierRequirementValuesView from "@/components/supplierRequirements/SupplierRequirementValuesView.vue";
import FileIcon from "@/components/FileIcon.vue";
import { useApplicationCalculator } from '@/lib/application';

export default {
  name: "ProcedureApplicationDialog",
  components: {SupplierRequirementValuesView, FileIcon, NdsDlg, FileInput, PositionsView},
  setup() {
    const dialogStore = useDialogStore();
    return {dialogStore};
  },
  props: {
    applicationId: Number,
    procedureId: Number,
    procedureStep: String,
    color: String,
    bgColor: String,
    statusName: String,
    withNds: Boolean,
    application: Object,
    tableReplaceCaption: String,
    procedureType: String,
    showStartMaxPrice: Boolean,
    applicationItemPriceField: String,
    showSumPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contragent: {
        fullName: null,
        inn: null,
        kpp: null,
        ogrn: null,
        phone: null,
        mail: null
      },
      chousenSum: 0,
      fullSum: 0,
      sums: {
        full: 0,
        chousen: 0
      },
      positions: [],
      supplierRequirementValues: [],
      documents: [],
      selectedApplic: null,
      isNdsDlgOpen: false,
    }
  },
  methods: {
    formatMoneyText,
    formatMinuteTimeNoTZ,
    async loadApplication() {
      const { contragent, positions, documents, sums, nds, supplierRequirementValues } = await api.get(
        `/applications/data/${this.applicationId}`
      );
      Object.assign(this.contragent, contragent);
      Object.assign(this.positions, positions.filter(pos => pos.quantity > 0 || pos.fullQuantity > 0));
      Object.assign(this.documents, documents);
      Object.assign(this.sums, sums);
      this.supplierRequirementValues = supplierRequirementValues;
      this.supplierRequirementValues?.forEach((elem) => {
        elem.valueDate = elem.valueDate ? new Date(
          elem.valueDate,
        ) : null;
      });
    },
    async downloadDocument(documentId) {
      window.location.href = `/applications/${this.applicationId}/documents/${documentId}`;
    },
    async downloadDocuments() {
      window.location.href = `/procedures/downloadAllDocumentsApplication/${this.procedureId}?applicationId=${this.applicationId}`;
    },
    checkValue(value) {
      return value?.length > 0 ? value : this.$t('Не указан');
    },
    closeAction() {
      this.dialogStore.closeDialog();
    },
    openDialog(isFullQuantity = false) {
      this.isNdsDlgOpen = true;
      this.selectedApplic = {
        offerPrice: this.application.offerPrice,
        positions: this.positions.map(pos => ({
          ...pos,
          quantity: isFullQuantity ? pos.fullQuantity : pos.quantity
        })),
        nds: {
          rate: this.ndsRate,
        }
      };
    },
  },
  computed: {
    ndsRate() {
      return this.application?.ndsRate !== null ? parseFloat(this.application.ndsRate) : null;
    },
    formatChousenSum() {
      const calculator = useApplicationCalculator(
          this.application,
          this.positions,
          this.ndsRate,
          this.applicationItemPriceField
      );
      return formatMoneyText(calculator.getChosenCostNds());
    },
    formatFullSum() {
      const calculator = useApplicationCalculator(
          this.application,
          this.positions,
          this.ndsRate,
          this.applicationItemPriceField
      );
      return formatMoneyText(calculator.getTotalCostNds());
    }
  },
  async mounted() {
    await this.loadApplication();
  }
}
</script>

<style scoped>
:deep(.v-chip) {
  margin-right: 16px;
}
:deep(.v-chip__content::before) {
  display: block;
  content: '';
  background-color: var(--circle-color);
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 6px;
}
:deep(.v-chip__content) {
  font-size: 14px;
  font-weight: 500;
}

.not-chousen {
  color: #B5B5B5;
  text-decoration: line-through;
}
</style>
